import { ATTENDEE_SCREEN_SHARE_CANCEL } from 'constants/SocketConstants';

function cancelScreenShareRequest() {
  return (_, getState, socket) => {
    const { meeting, knock } = getState();
    const { broadcastId } = knock || {};
    const { AttendeeId: attendeeId } = meeting?.attendeeResponse?.Attendee;

    if (broadcastId && attendeeId) {
      socket.emit(ATTENDEE_SCREEN_SHARE_CANCEL, {
        attendeeId,
        broadcastId
      });
    }
  };
}

export default cancelScreenShareRequest;
